import { useMutation } from 'react-query';
import api from '../../api/api';

async function deleteUser(id) {

  const route = `/users/${id}`;

  const response = await api
    .delete(route)
    .then((response) => response)
    .catch((error) => console.log('Error:', error));
  return response.data;
}

export function useDeleteUser() {
  return useMutation(
    async (data) => {
      await deleteUser(data.id);
    },
    {
      onSuccess: () => {},
      onError: () => {},
    }
  );
}
